import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CreateUsageHeaderInputType } from '@/graphql/contracts/_generated_/contracts';
import { CreateUsageHeader, CreateUsageHeaderVariables } 
  from '@/graphql/contracts/_generated_/createUsageHeader.mutation';
import { notificationService } from '@/services/notification/notification.client';
import CreateUsageHeaderMutation from '@/graphql/contracts/createUsageHeader.mutation.gql';

export default function useCreateUsageHeader() {
  const [_createUsageHeader, { loading, called, reset }] = useMutation<
  CreateUsageHeader,
  CreateUsageHeaderVariables
  >(CreateUsageHeaderMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const createUsageHeader = (fields: CreateUsageHeaderInputType, onSuccess?: () => void) => {
    if (!called) {
      _createUsageHeader({
        variables: { ...fields },
        onCompleted: () => {
          onSuccess?.();
          notificationService.open({
            title: 'File Import',
            text: 'File imported successfully',
            type: 'success',
          });
        },
      });
    }
  };

  return {
    createUsageHeader,
    isLoadingCreateUsageHeader: loading,
    resetCreateUsageHeader: reset,
  } as const;
}
